<template>
  <message v-if="message" type="negative">
    {{ message }}
  </message>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';

interface Data {
  message: string
}

export default defineComponent({
  components: {
    Message,
  },
  props: {
    task: Promise,
  },
  data(): Data {
    return {
      message: '',
    };
  },
  watch: {
    task(task: Promise<any>|null) {
      this.message = '';
      if (!task) return;
      task.catch((e: Error) => {
        this.message = e.message;
      });
    },
  },
});
</script>
